export default {
    logoLight(state) {
        return state.logoLight
    },
    logoDark(state) {
        return state.logoDark
    },
    getConfigurationOcrData(state) {
        return state.configurationOcrData
    },
}
